// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "screen and (max-width: 320px)";
var _4 = "container-2Xyhj";
export { _1 as "__esModule", _2 as "mobile", _3 as "iphone5", _4 as "container" }
export default { "__esModule": _1, "mobile": _2, "iphone5": _3, "container": _4 }
